import styled from 'styled-components';

const EmptyButton = styled.button`
  padding: 0;
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  outline: none;
  text-align: left;
  width: auto;
`;

export default EmptyButton;
